import { useCallback } from 'react';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useTitle } from 'react-use';

import OopsIcon from '@/components/atoms/Icons/Oops';
import { Button } from '@/components/ui/button';
import useSegments from '@/segment/useSegments';
import { PageName } from '@/shared/types/segment';

interface Props {
  resetErrorBoundary: () => void;
}

const Oops: React.FC<Props> = ({ resetErrorBoundary }) => {
  const { t } = useTranslation();
  useTitle(t('pages.error'));
  const navigate = useNavigate();

  const onButtonClick = useCallback(() => {
    resetErrorBoundary();
    navigate('/');
  }, [navigate, resetErrorBoundary]);

  useSegments(PageName.ERROR_500);

  return (
    <div className="mt-20 flex flex-col items-center">
      <div className="mb-6">
        <OopsIcon />
      </div>
      <div className="text-center text-4xl leading-11 font-medium text-foreground">
        {t('error_page.header')}
      </div>
      <div className="mt-3 text-center text-lg leading-7 font-normal">
        {t('error_page.subheader')}
      </div>
      <div className="mt-10">
        <Button onClick={onButtonClick} size="md">
          {t('error_page.return_home')}
        </Button>
      </div>
    </div>
  );
};

export default Oops;
